import styled from '@emotion/styled'
import { wrap as withStyle, stylesIf } from 'utils/styles'
import DynamicTabs from 'components/patterns/DynamicTabs'

// 20 on each side

export default withStyle((props) => {
  const { isPreCreate } = props
  return stylesIf(
    !isPreCreate,
    ` padding-left: 20px;
      width: 100%;
    `
  )
})

export const StyledDynamicTabs = styled(DynamicTabs)`
  margin-top: 10px;
  margin-bottom: 10px;
`
